import { gql } from '@apollo/client';

export const GQL_DELETE_PLAYER = gql`
  mutation DELETE_PLAYER($playerId: ID!) {
    deletePlayer(id: $playerId)
  }
`;

export const GQL_CREATE_PLAYER = gql`
  mutation CREATE_PLAYER($input: CreatePlayerInput!) {
    createPlayer(input: $input) {
      id
      name
    }
  }
`;

export const GQL_UPDATE_PLAYER = gql`
  mutation UPDATE_PLAYER($input: UpdatePlayerInput!) {
    updatePlayer(input: $input)
  }
`;

export const UPDATE_PLAYER_HOTLINK = gql`
  mutation UPDATE_PLAYER_HOTLINK($input: UpdatePlayertHotlinkInput!) {
    updatePlayerHotlink(input: $input)
  }
`;
